import { createSlice } from "@reduxjs/toolkit";

const versionSlice = createSlice({
  name: "version",
  initialState: {
    // null | "FORCE_REFRESH" | "SOFT_UPDATE" | "MAINTENANCE"
    versionAction: null,
    isBannerDismissed: false,
    serverBuild: null,
    minSupportedBuild: null,
    forceRefreshMessage: null,
    softUpdateMessage: null,
    maintenanceMessage: null,
  },
  reducers: {
    setVersionAction: (state, action) => {
      state.versionAction = action.payload;
    },
    setBannerDismissed: (state) => {
      state.isBannerDismissed = true;
    },
    setVersionInfo: (state, action) => {
      state.serverBuild = action.payload.serverBuild;
      state.minSupportedBuild = action.payload.minSupportedBuild;
      state.forceRefreshMessage = action.payload.forceRefreshMessage;
      state.softUpdateMessage = action.payload.softUpdateMessage;
      state.maintenanceMessage = action.payload.maintenanceMessage;
    },
  },
});

export const { setVersionAction, setBannerDismissed, setVersionInfo } = versionSlice.actions;
export default versionSlice.reducer;
